const PRIMARY_CHART_COLOUR = '#057ec1';

const GA_METRICS_I18N_PATH = `ANALYTICS.METRICS`;

const TOTAL_VISITORS_METRICS = `${GA_METRICS_I18N_PATH}.TOTAL_VISITORS`;
const TOTAL_VISITORS_CARD_TEXT = {
  title: { key: `${TOTAL_VISITORS_METRICS}.TITLE` },
  subtitle: { key: `${TOTAL_VISITORS_METRICS}.SUBTITLE` },
};

const PAGE_VIEWS_METRICS = `${GA_METRICS_I18N_PATH}.PAGE_VIEWS`;
const PAGE_VIEWS_CARD_TEXT = {
  title: { key: `${PAGE_VIEWS_METRICS}.TITLE` },
  subtitle: { key: `${PAGE_VIEWS_METRICS}.SUBTITLE` },
};

const PAGES_PER_SESSION_METRICS = `${GA_METRICS_I18N_PATH}.PAGES_PER_SESSION`;
const PAGES_PER_SESSION_CARD_TEXT = {
  title: { key: `${PAGES_PER_SESSION_METRICS}.TITLE` },
  subtitle: { key: `${PAGES_PER_SESSION_METRICS}.SUBTITLE` },
};

const BOUNCE_RATE_METRICS = `${GA_METRICS_I18N_PATH}.BOUNCE_RATE`;
const BOUNCE_RATE_CARD_TEXT = {
  title: { key: `${BOUNCE_RATE_METRICS}.TITLE` },
  subtitle: { key: `${BOUNCE_RATE_METRICS}.SUBTITLE` },
};

const GA_AVERAGE_SECONDS_ON_WEBSITE_METRICS = `${GA_METRICS_I18N_PATH}.AVERAGE_TIME_ON_WEBSITE`;
const GA_AVERAGE_SECONDS_ON_WEBSITE_CARD_TEXT = {
  title: { key: `${GA_AVERAGE_SECONDS_ON_WEBSITE_METRICS}.TITLE` },
  subtitle: { key: `${GA_AVERAGE_SECONDS_ON_WEBSITE_METRICS}.SUBTITLE` },
};

const GA_TOTAL_VISITS_METRICS = `${GA_METRICS_I18N_PATH}.TOTAL_VISITS`;
const GA_TOTAL_VISITS_CARD_TEXT = {
  title: { key: `${GA_TOTAL_VISITS_METRICS}.TITLE` },
  subtitle: { key: `${GA_TOTAL_VISITS_METRICS}.SUBTITLE` },
};

const GA_TRAFFIC_SOURCES_METRICS = `${GA_METRICS_I18N_PATH}.TRAFFIC_SOURCES`;
const GA_TRAFFIC_SOURCES_CARD_TEXT = {
  title: { key: `${GA_TRAFFIC_SOURCES_METRICS}.TITLE` },
  headingColumnTitle: { key: '' },
  columnTitle: { key: `${GA_TRAFFIC_SOURCES_METRICS}.COLUMN_TITLE` },
};

const GA_TOP_REFERRAL_SOURCES_METRICS = `${GA_METRICS_I18N_PATH}.TOP_REFERRAL_SOURCES`;
const GA_TOP_REFERRAL_SOURCES_CARD_TEXT = {
  title: { key: `${GA_TOP_REFERRAL_SOURCES_METRICS}.TITLE` },
  headingColumnTitle: { key: '' },
  columnTitle: { key: `${GA_TOP_REFERRAL_SOURCES_METRICS}.COLUMN_TITLE` },
};

const GA_GOALS_METRICS = `${GA_METRICS_I18N_PATH}.GOALS`;
const GA_GOALS_CARD_TEXT = {
  title: { key: `${GA_GOALS_METRICS}.TITLE` },
  headingColumnTitle: { key: `${GA_GOALS_METRICS}.HEADING_COLUMN_TITLE` },
  columnTitle: { key: `${GA_GOALS_METRICS}.COLUMN_TITLE` },
};

export const GA_TOTAL_VISITORS_CHART_CONFIG = {
  header: {
    title: TOTAL_VISITORS_CARD_TEXT.title,
    subtitle: TOTAL_VISITORS_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Users',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA_PAGE_VIEWS_CHART_CONFIG = {
  header: {
    title: PAGE_VIEWS_CARD_TEXT.title,
    subtitle: PAGE_VIEWS_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Page Views',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA_PAGES_PER_SESSION_CHART_CONFIG = {
  header: {
    title: PAGES_PER_SESSION_CARD_TEXT.title,
    subtitle: PAGES_PER_SESSION_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Pages Per Session',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA_BOUNCE_RATE_CHART_CONFIG = {
  header: {
    title: BOUNCE_RATE_CARD_TEXT.title,
    subtitle: BOUNCE_RATE_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Bounce Rate',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA_AVERAGE_SECONDS_ON_WEBSITE_CHART_CONFIG = {
  header: {
    title: GA_AVERAGE_SECONDS_ON_WEBSITE_CARD_TEXT.title,
    subtitle: GA_AVERAGE_SECONDS_ON_WEBSITE_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Average Time on Website',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA_TOTAL_VISITS_CHART_CONFIG = {
  header: {
    title: GA_TOTAL_VISITS_CARD_TEXT.title,
    subtitle: GA_TOTAL_VISITS_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Sessions',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA_TRAFFIC_SOURCES_CONFIG = {
  header: {
    title: GA_TRAFFIC_SOURCES_CARD_TEXT.title,
  },
  columnConfig: {
    columnTitles: [GA_TRAFFIC_SOURCES_CARD_TEXT.headingColumnTitle, GA_TRAFFIC_SOURCES_CARD_TEXT.columnTitle],
  },
};

export const GA_TOP_REFERRAL_SOURCES_CONFIG = {
  header: {
    title: GA_TOP_REFERRAL_SOURCES_CARD_TEXT.title,
  },
  columnConfig: {
    columnTitles: [GA_TOP_REFERRAL_SOURCES_CARD_TEXT.headingColumnTitle, GA_TOP_REFERRAL_SOURCES_CARD_TEXT.columnTitle],
  },
};

export const GA_GOALS_CONFIG = {
  header: {
    title: GA_GOALS_CARD_TEXT.title,
  },
  column: {
    headingColumnTitle: GA_GOALS_CARD_TEXT.headingColumnTitle,
    columnTitle: GA_GOALS_CARD_TEXT.columnTitle,
  },
};
export const COLLECTION_DAYS_THRESHOLD = 89;
